function createNewEvent(eventName) {
	var event;
	if (typeof Event === 'function') {
		event = new Event(eventName);
	} else {
		event = document.createEvent('Event');
		event.initEvent(eventName, true, true);
	}
	return event;
}

// Create custom deselect events for radios
window.addEventListener('change', e => {
	if (e.target.matches('input[type="radio"]')) {
		const { name } = e.target;
		const radios = document.querySelectorAll(`input[name="${name}"]`);
		radios.forEach(radio => {
			if (radio !== e.target) {
				radio.dispatchEvent(createNewEvent('deselect'));
			}
		});
	}
});
